import React from "react"

import HotTable from "../utils/hot-table";

export default class PPIExpenses extends React.Component {
	render() {

		return (
			<div className="expenses-container">
				<HotTable
					root="expenses"
					headers={false}
					data={this.props.data}
					ppi={this.props.ppi}
					tableDefinition={this.props.tableDefinition}
					onCustomAction={this.props.onCustomAction}
					onChange={this.props.onChange}
					previousYear={this.props.previousYear}
					currentUserType = {this.props.currentUserType}
				/>
				{ this.props.consulted
					? null
					: <div className="expenses-actions">
							<button onClick={this._handleClick.bind(this)} title="Ajouter une dépense"><i className="fa fa-plus" /></button>
						</div>
				}
			</div>
		)
	}

	_handleClick(e) {
		this.props.onCustomAction("new_expense")
	}
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/expenses/table-component.js